import React, { useState } from 'react';
import { useUI } from '../../DataStore/UIContext';
import Notification from '../Common/Notification';
import BsModal from '../Common/BsModal';
import ActivityLoader from '../Common/ActivityLoader';
import ajaxNetwork from '../../util/remote/ajaxNetwork';

const AlertDisconnectDevice = ({show, onClose, onSuccess, selectedMacs, voucherId}) => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useUI();


    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxNetwork.disconnectDevices(selectedMacs, voucherId);
        setLoading(false);
        if(server_response.status === "OK"){
            onSuccess();
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        onClose();

    }

    return (
        <BsModal
            show={show}
            onClose={onClose}
            title="Block Device"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    {selectedMacs && <button className="btn btn-danger" onClick={confirm}>
                        Confirm Block
                    </button>}
                    </>}
                </>
            }
        >


            {selectedMacs && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{ fontSize: '17px' }}>Please confirm that you want to block the device selection from this voucher.</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>The device will be revoked from this voucher and will no longer have access.
                </p>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDisconnectDevice;
